export default __webpack_public_path__ + "static/10a288dfc3ec85372e837285c460a342.ttf";